// Warehouse/Branch information for delivery pickup points
export interface WarehouseInfo {
  id: number;
  pick_address: string;
  pick_province: string;
  pick_district: string;
  pick_ward: string;
  pick_tel: string;
}

export const WAREHOUSE_DATA: WarehouseInfo[] = [
  {
    id: 488,
    pick_address: "Số 131 Lê Thanh Nghị , Đồng Tâm , Hai Bà Trưng , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hai Bà Trưng",
    pick_ward: "Đồng Tâm",
    pick_tel: "0988655130",
  },
  {
    id: 489,
    pick_address: "Số 284 , Thái Hà , Đống Đa , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Đống Đa",
    pick_ward: "Thái Hà",
    pick_tel: "0988655130",
  },
  {
    id: 491,
    pick_address: "Số 79 Nguyễn Văn Huyên , Quan Hoa , Cầu Giấy , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Cầu Giấy",
    pick_ward: "Quan Hoa",
    pick_tel: "0988655130",
  },
  {
    id: 492,
    pick_address: "Số 313 Quang Trung ,Phú La, Hà Đông , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hà Đông",
    pick_ward: "Phú La",
    pick_tel: "0988655130",
  },
  {
    id: 494,
    pick_address: "Số 622 Nguyễn Văn Cừ ,Gia Thụy , Long Biên , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Long Biên",
    pick_ward: "Gia Thụy",
    pick_tel: "0988655130",
  },
  {
    id: 496,
    pick_address: "62 Nguyễn Hữu Thọ, Hoàng Liệt, Hoàng Mai, Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hoàng Mai",
    pick_ward: "Đại Kim",
    pick_tel: "0988655130",
  },
  {
    id: 221,
    pick_address: "Số 57 Trần Phú ,Văn Quán, Hà Đông , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hà Đông",
    pick_ward: "Văn Quán",
    pick_tel: "0988655130",
  },
  {
    id: 2701,
    pick_address: "Số 805 Giải Phóng ,Giáp Bát, Hoàng Mai , Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hoàng Mai",
    pick_ward: "Giáp Bát",
    pick_tel: "0988655130",
  },
  {
    id: 2721,
    pick_address:
      "Số 43 Louis 8 , Hoàng Mai, Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hoàng Mai",
    pick_ward: "Yên Sở",
    pick_tel: "0988655130",
  },
  {
    id: 493,
    pick_address: "Số 478 Cách Mạng Tháng Tám, Quận 3, Hồ Chí Minh",
    pick_province: "Hồ Chí Minh",
    pick_district: "Quận 3",
    pick_ward: "Phường 11",
    pick_tel: "0931435431",
  },
  {
    id: 2781,
    pick_address: "34 Trần Não, Phường An Khánh, Hồ Chí Minh",
    pick_province: "Hồ Chí Minh",
    pick_district: "Thủ Đức",
    pick_ward: "Phường An Khánh",
    pick_tel: "0901391682",
  },
  {
    id: 2782,
    pick_address: "783 Phan Văn Trị, Phường Hạnh Thông, Hồ Chí Minh",
    pick_province: "Hồ Chí Minh",
    pick_district: "Quận Gò Vấp",
    pick_ward: "Phường 1",
    pick_tel: "0908971358",
  },
  {
    id: 2741,
    pick_address: "Số 87 Trần Duy Hưng - Yên Hoà - Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Cầu Giấy",
    pick_ward: "Yên Hoà",
    pick_tel: "0988655130",
  },
  {
    id: 124,
    pick_address: "124 Minh Khai, Hai Bà Trưng, Hà Nội",
    pick_province: "Hà Nội",
    pick_district: "Hai Bà Trưng",
    pick_ward: "Minh Khai",
    pick_tel: "0988655130",
  },
];
